import React from "react";
import moment from 'moment';
import DatePicker from "react-datepicker";
import Question from '../components/Question'
import { Form } from 'react-bootstrap'
import QuoteStep from "./QuoteStepLayout";
import QuoteStepBase, { mapInsuranceStepProps } from '../components/QuoteStepBase'
import ButtonContinue from "../components/ButtonContinue";
import Calendar from "../components/Calendar";
import Utilities from "../classes/Utilities";
import { IQuoteStepState, ICurrentInsuranceStepProps } from "../components/interfaces";
import { ValidatableForm } from "../components/ValidatableForm";
import { connect } from "react-redux";
import { validationUtils } from "../validation/Validation";
import { QUOTE_STEPS, COMPONENTS, QUOTE_QUESTIONS } from "../AppConstants";
import { IQuoteApiClient, IPaths, IToolTipOption } from "../classes/Domain";
import QuoteActions from "../state/appActions";


const tomorrow = moment(new Date()).add(1, 'd').toDate();
const today = new Date();

interface IYourNewPolicyState extends IQuoteStepState {
    hasInsurance: string | null,
    currentInsuranceCompanyMonths: string | null,
    currentPolicyExpirationDate: Date,
    effectiveDate : string
}

export interface IProps extends ICurrentInsuranceStepProps {
    nextPageUrl?: string,
    quoteApiClient: IQuoteApiClient,
    PATHS: IPaths;
}


interface IOtherEffDateProps {
    selected?: boolean,
    value?: string,
    label: string,
    onSelected?: () => void,
    onClick?: () => void;
}


class YourNewPolicy extends QuoteStepBase<IProps, IYourNewPolicyState> {
    constructor(props: IProps) {
        super(props);
        this.next = this.next.bind(this);
        this.onEffDateChange = this.onEffDateChange.bind(this);
                
        this.state = {
            currentPolicyExpirationDate: tomorrow,
            effectiveDate: today.toDateString(),
            hasInsurance: null,
            currentInsuranceCompanyMonths: null,
            updatingStore: false,
            errors: null
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            const currentInsurance = nextProps.currentInsurance;
            nextProps.meta.propsSource = "";
            if (!currentInsurance) return prevState;

            return {
                ...prevState,
                currentPolicyExpirationDate: currentInsurance.currentPolicyExpirationDate,
               // effectiveDate: currentInsurance.effectiveDate,
                hasInsurance: currentInsurance.hasInsurance,
                currentInsuranceCompanyMonths: currentInsurance.currentInsuranceCompanyMonths
            };
        }

        return prevState;
    }

    next() {
        this.setState({ updatingStore: true }, () => {
            const updatedCurrentInsurance = {
                ...this.props.currentInsurance,
                currentPolicyExpirationDate: this.state.currentPolicyExpirationDate,
                effectiveDate: this.state.effectiveDate,
                hasInsurance: this.state.hasInsurance,
                currentInsuranceCompanyMonths: this.state.currentInsuranceCompanyMonths
            };

            const nextStepUrl = Utilities.formatUrl(this.props.nextPageUrl ?? this.props.PATHS.CONTACT_INFO);

            this.props.updateAppState({ quoteUid: this.props.quoteUid, currentInsurance: updatedCurrentInsurance })
                .then(() => this.props.history.push(nextStepUrl),
                    () => {
                        this.setState({ ...this.state, updatingStore: false });
                    });
        });
    }

    static formatPolicyExpiresOption(date: Date | null) {
        if (!date) return "";
        return QUOTE_QUESTIONS.NEW_POLICY.EFF_DATE_OPTIONS.WHEN_POLICY_EXPIRES + " (" + (date.getMonth() + 1) + "/" + date.getDate() + ")";
    }

    onEffDateChange(date: Date | null) {
        if (date) {
            this.setState({
                ...this.state,
                effectiveDate: date?.toDateString()
            });
        }
    }

    priorCoverageCallbackFunction = (childData: string) => {
        if (childData === QUOTE_QUESTIONS.YES_NO.YES)
        {
            this.setState({ ...this.state, hasInsurance: childData });
        }
        else
        {
            this.setState({ ...this.state, hasInsurance: childData, currentInsuranceCompanyMonths: null });
        }
    };

    currentInsuranceCompanyMonthsCallbackFunction = (childData: string) => {
        this.setState({ ...this.state, currentInsuranceCompanyMonths: childData });
    };


    render() {
        return (
            <QuoteStep id={this.props.id}>
                <ValidatableForm hasErrors={null != this.state.errors}>
                    <div className="titleArea"><h5>YOUR NEW POLICY</h5></div>

                    <Form.Group>
                        <Form.Label>Policy Effective Date</Form.Label>
                        <Calendar
                            id="effectiveDate"
                            value={new Date(this.state.effectiveDate)}
                            minDate={today}
                            maxDate={moment(new Date()).add(30, 'd').toDate()}
                            validated={null !== this.state.errors}
                            validationError={validationUtils.getValidationErrorFor(this.state.errors, "effectiveDate")}
                            onChange={this.onEffDateChange} />
                    </Form.Group>

                    {
                        this.props.stateCode === "TX"
                            ?
                            <Question
                                name="hasInsurance"
                                error={validationUtils.hasValidationErrorFor(this.state.errors, "hasInsurance") ? this.state.errors["hasInsurance"][0] : ""}
                                selected={this.priorCoverageCallbackFunction}
                                selectedValue={this.state.hasInsurance}
                                items={[QUOTE_QUESTIONS.YES_NO.YES, QUOTE_QUESTIONS.YES_NO.NO]}
                                lable="Prior Coverage ?"
                                tooltip={{ title: "Info", content: "Prior Coverage Discount is allowable with no more than a 30 day lapse, unless the insured has not operated an uninsured motor vehicle in the state for more than 30 days within the past 12 months in which discount will be allowable with any length of lapse." } as IToolTipOption}
                            />
                            : null
                    }

                    {
                        this.props.stateCode === "TX"
                            ?
                            <Question
                                name="currentInsuranceCompanyMonths"
                                error={validationUtils.hasValidationErrorFor(this.state.errors, "currentInsuranceCompanyMonths") ? this.state.errors["currentInsuranceCompanyMonths"][0] : ""}
                                selected={this.currentInsuranceCompanyMonthsCallbackFunction}
                                selectedValue={this.state.currentInsuranceCompanyMonths}
                                style={{ display: this.state.hasInsurance === QUOTE_QUESTIONS.YES_NO.YES ? '' : 'none' }}
                                items={[QUOTE_QUESTIONS.CURRENT_INSURANCE.INSURED_PERIOD.SIX_MONTHS, QUOTE_QUESTIONS.CURRENT_INSURANCE.INSURED_PERIOD.TWELVE_MONTHS]}
                                lable="Prior insurance coverage for ?" />
                            : null
                    }

                    <div className="btnContainer">
                        <Form.Label>By clicking the "Continue" button below you consent to sign and receive insurance policy documents electronically</Form.Label>
                        <ButtonContinue
                            disabled={this.state.updatingStore}
                            showLoading={this.state.updatingStore}
                            onClick={this.next} />
                    </div>

                </ValidatableForm>
            </QuoteStep>
        );
    }
}

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);

    return {
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(QUOTE_STEPS.NEW_POLICY)),
        updateAppState: (update) => dispatch(quoteActions.updateInsurance(update.quoteUid, update.currentInsurance, QUOTE_STEPS.NEW_POLICY, ownProps.stateCode))
    };
};

export default connect(mapInsuranceStepProps, mapDispatch)(YourNewPolicy);
